const handleCloseFormCompany = {
  text: '¿Realmente desea salir sin guardar sus cambios?',
  title: 'CAMBIOS NO GUARDADOS'
};

export default handleCloseFormCompany;
